import { Component, Input, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { KeywordService } from '../../services/keyword.service';
import { NgIf, NgFor } from '@angular/common';
import { LazyImgDirective } from '../../lazy-img.directive';

@Component({
    selector: 'fw-keyword-search-results',
    templateUrl: './keyword-search-results.component.html',
    styleUrls: ['./keyword-search-results.component.scss'],
    imports: [NgIf, NgFor, RouterLink, LazyImgDirective]
})
export class KeywordSearchResultsComponent implements OnInit {

  @Input() public results: any = [];
  public imgRoot = 'https://maritime-photographie.de/dev/img/images/middle/';

  constructor(private keywordSrv: KeywordService, private router: Router) { }

  ngOnInit() {
    this.keywordSrv.searchResults.asObservable().subscribe((results) => {
      this.results = results;
    });

    this.router.events.subscribe(() => {
      this.results = [];
    });
  }

}
